import { RegisterUserModel } from "./RegisterUserModels";
import { Reducer } from "redux";

export enum ActionType {
    RegisterUserRequest = "REGISTER/USER_REQUEST",
    RegisterUserSubmitted = "REGISTER/USER_SUBMITTED",
    RegisterUserCancelled = "REGISTER/USER_CANCELLED",
    RegisterUserSuccess = "REGISTER/USER_SUCCESS",
    RegisterUserContinueToLogin = "RegisterUserContinueToLogin",
    Error = "REGISTER/USER_ERROR"
}

export interface RegisterUserRequestAction {
    type: ActionType.RegisterUserRequest,
    identifier: string
}

interface RegisterUserSubmittedAction {
    type: ActionType.RegisterUserSubmitted,
    data: RegisterUserModel
}

interface RegisterUserCancelledAction {
    type: ActionType.RegisterUserCancelled
}

interface RegisterUserSuccessAction {
    type: ActionType.RegisterUserSuccess
}

interface RegisterUserContinueToLoginAction {
    type: ActionType.RegisterUserContinueToLogin
}

interface ErrorAction {
    type: ActionType.Error,
    error: any
}


export const actionCreators = {
    registerUserRequest: (identifier: string) => <RegisterUserRequestAction>{ type: ActionType.RegisterUserRequest, identifier },
    registerUserSubmitted: (data: RegisterUserModel) => <RegisterUserSubmittedAction>{ type: ActionType.RegisterUserSubmitted, data },
    registerUserCancelled: () => <RegisterUserCancelledAction>{ type: ActionType.RegisterUserCancelled },
    registerUserSuccess: () => <RegisterUserSuccessAction>{ type: ActionType.RegisterUserSuccess },
    registerUserContinueToLogin: () => <RegisterUserContinueToLoginAction>{ type: ActionType.RegisterUserContinueToLogin },
    registerError: (error: any) => <ErrorAction>{ type: ActionType.Error, error }
}

export interface RegisterUserState {
    success: boolean;
}

type RegisterAction = RegisterUserRequestAction | RegisterUserSuccessAction;

const initialState = {
    success: false
}

export const reducer: Reducer<RegisterUserState> = (state: RegisterUserState, action: RegisterAction) => {
    switch (action.type) {
        case ActionType.RegisterUserRequest:
            return {
                success: false
            }
        case ActionType.RegisterUserSuccess:
            return {
                success: true
            };
        default:
            // exhaustive check    
            const check: never = action;
    }

    return state || initialState;
}


// WEBPACK FOOTER //
// ./src/register/user/registerUserStore.ts